import { render, staticRenderFns } from "./PopupNotification.vue?vue&type=template&id=6c103379&scoped=true&"
import script from "./PopupNotification.vue?vue&type=script&lang=ts&"
export * from "./PopupNotification.vue?vue&type=script&lang=ts&"
import style0 from "./PopupNotification.vue?vue&type=style&index=0&id=6c103379&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c103379",
  null
  
)

export default component.exports